var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmhfwWEk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349.000000, -723.000000) translate(337.000000, 714.000000) translate(12.000000, 9.201843)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 22,
    x: -1,
    y: 3.798,
    stroke: "#FFF",
    strokeWidth: 2,
    rx: 4,
    transform: "translate(12.000000, 14.798157) rotate(-270.000000) translate(-12.000000, -14.798157)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 13.798L17 13.798M5 17.798L17 17.798M5 21.798L13 21.798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 21.798,
    r: 1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M17.235 2L17.235 7.798 22.612 7.798"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmhfwWEk);
export default __webpack_public_path__ + "static/media/TmhfwWEk.1b4546544090cc4d198ccaebc963fc3c.svg";
export { ForwardRef as ReactComponent };